import {NumberCol, RenderStringCol, Table, ViewOnly} from "../../../../misc/scroller/Table";
import {api} from "../../../../api/API";
import {useProjectId, useProjectUnitSystem} from "../../shopdrawing/ProjectName";
import {FrameProfile} from "../../../../api/Openings";
import ChevronLeft from "@mui/icons-material/ChevronLeft";
import {Grid, IconButton} from "@mui/material";
import React from "react";
import {useIsQuote} from "../QuoteContainer";
import {useAlternative} from "../alternative/Alternative";
import {FrameProfilePopup} from "../../settings/FrameProfilePopup";

export function ReviewTitle(props: {
    name: string;
    onDone(): void;
}) {
    return (
        <Grid container spacing={1} alignItems="center">
            <Grid item>
                <IconButton onClick={props.onDone}>
                    <ChevronLeft />
                </IconButton>
            </Grid>
            <Grid item>
                {props.name}
            </Grid>
        </Grid>
    )
}

export function ReviewFrameProfiles() {
    const project = useProjectId();
    const sys = useProjectUnitSystem();
    const isQuote = useIsQuote();
    const alt = useAlternative();

    if(!sys) return null;

    return (
        <Table<FrameProfile>
            name={"frame-profiles"}
            fetch={ctx => {
                return isQuote ? api.quoteOpenings.listFrameProfiles({
                        project: project,
                        alternative: alt,
                    }) : api.openings.listFrameProfiles({
                        project: project,
                    })
            }}
            fetchDeps={[project, alt, isQuote]}
            columns={[
                {
                    name: "Frame Profile",
                    width: 200,
                    editable: {
                        type: "custom",
                        render: (props) => {
                            return <FrameProfilePopup
                                entityName={props.row.frameProfile}
                                file={props.row.frameProfileFile}
                                name={props.row.frameProfileFileName}
                                onCancel={props.onCancel}
                                onDone={async (v) => {
                                    props.onCancel()
                                }}
                            />
                        }
                    },
                    render: (data, col) => {
                        return data.frameProfile || "";
                    },
                },
                {
                    name: "Has Attachment",
                    width: 100,
                    render: data => {
                        return data.frameProfileFile ? "Yes" : "No";
                    }
                },
                ViewOnly(NumberCol("Qty", "count")),
                RenderStringCol("-", () => ""),
            ]}
        />
    )
}